'use strict';

var Classnames = require('classnames');
var React = require('react');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./radio.scss');
}

var Radio = React.createClass({
    propTypes: {
        // handleChange: React.PropTypes.function,
        group: React.PropTypes.string,
        ident: React.PropTypes.number,
        checked: React.PropTypes.bool,
        active: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            active: true,
        };
    },
    focus: function() {
        ReactDOM.findDOMNode(this.refs.radio).focus();
    },
    render: function() {
        var classes = Classnames({
            'sp-radio': true,
            'sp-radio-inactive': !this.props.active,
        });
        return (
            <span className={classes}>
                <input ref            = 'radio'
                       type           = 'radio'
                       group          = {this.props.group}
                       id             = {'radio-' + this.props.ident}
                       onChange       = {this.props.handleChange}
                       value          = {this.props.ident}
                       checked        = {this.props.checked}
                />
                <label htmlFor={'radio-' + this.props.ident}>
                    <span className='radio-placeholder'></span>
                    {this.props.label}
                </label>
            </span>
        );
    },
});

module.exports = Radio;



// WEBPACK FOOTER //
// ./src/forms/radio.jsx